import type { Operator } from "./index.js"

// Operators with `value: "none"` — no value input required.

export const isEmpty: Operator = {
  key: "isEmpty",
  label: "is empty",
  icon: "circle",
  value: "none",
  fn: (a) => a == null || a === "" || (Array.isArray(a) && a.length === 0),
}

export const isNotEmpty: Operator = {
  key: "isNotEmpty",
  label: "is not empty",
  icon: "circle-dot",
  value: "none",
  fn: (a) => a != null && a !== "" && !(Array.isArray(a) && a.length === 0),
}

export const isTrue: Operator = {
  key: "isTrue",
  label: "is true",
  icon: "check",
  value: "none",
  fn: (a) => a === true,
}

export const isFalse: Operator = {
  key: "isFalse",
  label: "is false",
  icon: "xmark",
  value: "none",
  fn: (a) => a === false,
}
